import {envIsPublicCloud} from '../../../config';
import {PlanName} from '../../../pages/Billing/util';
import {type Viewer} from '../../../state/viewer/types';
import {
  getPrimarySub,
  isExpiredSubscription,
  isNonAcademicOrg,
} from '../../../util/accounts/pricing';
import {type TrialSubscriptionExpiredBannerProps} from '../ExpirationEnforcementBanners/types';
import {type ViewerOrg} from '../types';
import {orgFromViewerOrg} from '../utils';

export type FreeAccountEnforcementBannerFlags = {
  trialSubscriptionExpiredBannerProps?: TrialSubscriptionExpiredBannerProps;
};

export async function getFreeAccountEnforcementBannerFlags(
  viewer?: Viewer,
  org?: ViewerOrg
): Promise<FreeAccountEnforcementBannerFlags> {
  const flags: FreeAccountEnforcementBannerFlags = {};

  if (org == null || viewer == null) {
    return flags;
  }

  if (!envIsPublicCloud) {
    return flags;
  }

  if (!isNonAcademicOrg(org)) {
    return flags;
  }

  const organization = orgFromViewerOrg(org);

  const primarySubscription = getPrimarySub(organization);
  const currentPrimaryPlanName = primarySubscription?.plan?.name;

  if (
    primarySubscription != null &&
    currentPrimaryPlanName === PlanName.TrialPlan &&
    isExpiredSubscription(primarySubscription)
  ) {
    flags.trialSubscriptionExpiredBannerProps = {
      organizationId: org.id,
    };
  }

  return flags;
}
